import React from 'react';
import PropTypes from 'prop-types';
import { formatPriceStringV2 } from 'client/site-modules/shared/utils/price-utils';
import { ExplanatoryText } from 'site-modules/lease-deals/components/key-insights-list/explanatory-text';

export function LifetimeCostInsight({
  lifetimeCost,
  dueAtSigning,
  monthlyPayment,
  term,
  effectivePayment,
  isShop4931ZeroDownRoute = false,
}) {
  const details = isShop4931ZeroDownRoute
    ? `This is what you'll pay over the duration of the lease, equal to ${term} payments of ${formatPriceStringV2(effectivePayment)}/mo.`
    : `This is what you'll pay over the duration of the lease, equal to an initial payment of ${formatPriceStringV2(dueAtSigning)} and ${term - 1} additional payments of ${formatPriceStringV2(monthlyPayment)}/mo.`;

  return (
    <ExplanatoryText
      summary={
        <span>
          <strong>{formatPriceStringV2(lifetimeCost)}</strong>{' '}
        </span>
      }
      toggleSummary="lifetime cost"
      details={details}
    />
  );
}

LifetimeCostInsight.propTypes = {
  lifetimeCost: PropTypes.number.isRequired,
  dueAtSigning: PropTypes.number.isRequired,
  monthlyPayment: PropTypes.number.isRequired,
  term: PropTypes.number.isRequired,
  effectivePayment: PropTypes.number,
  isShop4931ZeroDownRoute: PropTypes.bool,
};
